import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { Login } from './pages/Login';
import { ResetPassword } from './pages/ResetPassword';
import { UpdatePassword } from './pages/UpdatePassword';
import { Dashboard } from './pages/Dashboard';
import { PrivateRoute } from './components/PrivateRoute';
import { SuperAdminRoute } from './components/SuperAdminRoute';
import { Reports } from './pages/Reports';
import { SimManagement } from './pages/sims/SimManagement';
import { Wallet } from './pages/Wallet';
import { Navigation } from './components/Navigation';
import { Box } from '@mui/material';
import { ClusterManagement } from './pages/clusters/ClusterManagement';
import { NotificationsPage } from './pages/NotificationsPage';
import { RequestSims } from './pages/RequestSims';
import { AdjustWallet } from './pages/admin/AdjustWallet';
import { SubmitRequest } from './pages/SubmitRequest';
import { ManageRequests } from './pages/admin/ManageRequests';
import { ProcessRequest } from './pages/admin/ProcessRequest';
import { RecordPaymentPage } from './pages/admin/RecordPaymentPage';
import { NewOrganization } from './pages/organizations/NewOrganization';
import { EditOrganization } from './pages/organizations/EditOrganization';
import { OrganizationListPage } from './pages/admin/OrganizationListPage';

// Create a theme instance
const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#1976d2',
    },
    secondary: {
      main: '#0dbd65',
    },
    background: {
      default: '#f5f5f5',
      paper: '#ffffff',
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/login" element={<Login />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/update-password" element={<UpdatePassword />} />
            <Route
              path="/"
              element={
                <PrivateRoute>
                  <Box sx={{ display: 'flex' }}>
                    <Navigation />
                    <Box component="main" sx={{ flexGrow: 1, p: 3, mt: 8 }}>
                      <Outlet />
                    </Box>
                  </Box>
                </PrivateRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="sims" element={<SimManagement />} />
              <Route path="clusters" element={<ClusterManagement />} />
              <Route path="reports" element={<Reports />} />
              <Route path="wallet" element={<Wallet />} />
              <Route path="notifications" element={<NotificationsPage />} />
              <Route path="request-sims" element={<RequestSims />} />
              <Route path="submit-request" element={<SubmitRequest />} />
              <Route path="admin/requests" element={<SuperAdminRoute><ManageRequests /></SuperAdminRoute>} />
              <Route path="admin/process-request/:requestId" element={<ProcessRequest />} />
              <Route path="admin/organizations" element={<SuperAdminRoute><OrganizationListPage /></SuperAdminRoute>} />
              <Route path="admin/organizations/new" element={<SuperAdminRoute><NewOrganization /></SuperAdminRoute>} />
              <Route path="admin/organizations/:id/edit" element={<SuperAdminRoute><EditOrganization /></SuperAdminRoute>} />
              <Route path="admin/adjust-wallet" element={<SuperAdminRoute><AdjustWallet /></SuperAdminRoute>} />
              <Route path="admin/record-payment" element={<SuperAdminRoute><RecordPaymentPage /></SuperAdminRoute>} />
            </Route>
            <Route path="*" element={<div>404 Not Found - Public</div>} />
          </Routes>
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;

